import { useEffect } from 'react';
import { PopupScrollableWrapper } from '@elfsight/widget-modal';

const MAX_RETRIES = 60;

export const useScrollToPost = (index: number, selector: string): void => {
  useEffect(() => {
    if (index === -1) return;

    let rafId: number;
    let cancelled = false;
    let retries = 0;

    const tryScroll = () => {
      if (cancelled) return;

      const scrollableWrapper = document.querySelector(PopupScrollableWrapper);

      if (!scrollableWrapper) {
        if (retries < MAX_RETRIES) {
          retries += 1;
          rafId = requestAnimationFrame(tryScroll);
        }
        return;
      }

      const posts = document.querySelectorAll(selector);
      const currentPost = posts[index] as HTMLElement;

      if (!currentPost) {
        return;
      }

      queueMicrotask(() => {
        if (cancelled) return;
        const { offsetTop, offsetParent } = currentPost;
        const { offsetTop: parentOffsetTop = 0 } =
          (offsetParent as HTMLElement) || {};
        scrollableWrapper.scrollTop = offsetTop + parentOffsetTop;
      });
    };

    rafId = requestAnimationFrame(tryScroll);

    return () => {
      cancelled = true;
      cancelAnimationFrame(rafId);
    };
  }, [index, selector]);
};
